var React = require('react');

function HamburgerInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Burger"),React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"NavigTop_big_logo","transform":"translate(-1340.000000, -24.000000)","fill":"#020303"},React.createElement("g",{"id":"Page-1","transform":"translate(1340.000000, 24.000000)"},[React.createElement("polygon",{"id":"Fill-1","points":"0 1 20 1 20 0 0 0","key":0}),React.createElement("polygon",{"id":"Fill-2","points":"0 5 20 5 20 4 0 4","key":1}),React.createElement("polygon",{"id":"Fill-3","points":"0 9 20 9 20 8 0 8","key":2})])))]);
}

HamburgerInline.defaultProps = {"width":"20px","height":"9px","viewBox":"0 0 20 9","version":"1.1"};

module.exports = HamburgerInline;

HamburgerInline.default = HamburgerInline;
